import React from 'react'
import Moment from 'react-moment'
import {
  Divider } from 'semantic-ui-react'

import { 
  Cont, 
  ContDetail } from './styled'

export const ProcessRow = ({ data }) => {

  return (
    <Cont>
      <ContDetail>
        <div>Commented by : </div>
        <div>{data&&data.createdByName}</div>
      </ContDetail>
      <ContDetail>
        <div>Commented date : </div>
        <div><Moment format="DD MMM YYYY HH:mm">{data&&data.createdDate}</Moment></div>
      </ContDetail>
      <ContDetail>
        <div>Activity : </div>
        <div>{data&&data.activity}</div>
      </ContDetail>
      <ContDetail>
        <div>Action : </div>
        <div>{data&&data.action}</div>
      </ContDetail>
      <ContDetail>
        <div>Comment : </div>
        <div>{data&&data.comment||'-'}</div>
      </ContDetail>
      <Divider/>
    </Cont>
  )
}